<dojo-text-input
  [formCtrl]="formCtrl"
  [placeholder]="placeholder"
  [compact]="compact"
  [size]="size"
  [label]="label"
  [type]="'text'"
  [hasInitialFocus]="hasInitialFocus"
  [fullWidthField]="fullWidthField"
  id="searchInput"
>
  <ng-container y42InputPrefix>
    <dojo-icon [icon]="icon" [iconClass]="'text-neutral-500'" [size]="size === 'xs' || size === 's' ? 14 : 16" />
  </ng-container>
  <ng-container dojoInputSuffix>
    <button
      mat-icon-button
      (click)="formCtrl.reset('')"
      [style.visibility]="formCtrl.value.length > 0 ? 'visible' : 'hidden'"
    >
      <dojo-icon
        [icon]="'times'"
        [matTooltip]="'home_card.clear_search' | transloco"
        [iconClass]="'text-neutral-500'"
        [size]="size === 'xs' || size === 's' ? 14 : 16"
      />
    </button>
  </ng-container>
</dojo-text-input>
